import { __assign } from "tslib";
import React, { useEffect, useMemo, useState } from 'react';
import { useCnRequest } from '@cainiaofe/cn-ui-common';
import { useLatest } from 'ahooks';
export var FormatEnumeration = function (props) {
    var value = props.value, _a = props.column, column = _a === void 0 ? {} : _a;
    var _b = column.options, options = _b === void 0 ? {} : _b;
    var dataSourceProps = options.dataSource, requestConfig = options.requestConfig;
    var _c = useState([]), dataSource = _c[0], setDataSource = _c[1];
    var _d = useState(!dataSourceProps), loading = _d[0], setLoading = _d[1];
    var requestConfigRef = useLatest(requestConfig);
    var runAsync = useCnRequest(__assign({ manual: true, cacheKey: "".concat(requestConfig === null || requestConfig === void 0 ? void 0 : requestConfig.url, "+").concat(requestConfig === null || requestConfig === void 0 ? void 0 : requestConfig.method, "+").concat(JSON.stringify((requestConfig === null || requestConfig === void 0 ? void 0 : requestConfig.params) || {})), staleTime: 5000 }, requestConfig)).runAsync;
    useEffect(function () {
        if (dataSourceProps || !value) {
            setLoading(false);
            return;
        }
        var config = requestConfigRef.current;
        if (config) {
            runAsync()
                .then(function (data) { return setDataSource(data); })
                .finally(function () { return setLoading(false); });
        }
    }, [dataSourceProps, requestConfigRef, runAsync, value]);
    var result = useMemo(function () {
        var _a;
        if (!value)
            return;
        var list = dataSourceProps || dataSource;
        if (Array.isArray(value)) {
            return value
                .map(function (valueItem) { var _a; return (_a = list.find(function (item) { return item.value === valueItem; })) === null || _a === void 0 ? void 0 : _a.label; })
                .filter(Boolean)
                .join(',');
        }
        return (_a = list.find(function (item) { return item.value === value; })) === null || _a === void 0 ? void 0 : _a.label;
    }, [dataSource, dataSourceProps, value]);
    if (loading)
        return null;
    return React.createElement(React.Fragment, null, result || value || '- -');
};
